import { useEffect } from 'react'
import {
    ids,
    loadUserAPI,
    LogoutListener,
    pianoUserLogin,
    pianoUserRegister,
    saveUser,
} from '@/components/ThirdParty/Piano/util'
import { clearAllCookies } from '@/utils/cookie'

const PianoSupport = () => {
    useEffect(() => {
        // eslint-disable-next-line no-console
        console.debug('render-test: useEffect PianoSupport')

        // setting the logout Listener
        // if it is not already set! that should not happen, only if a
        // wrapping provider triggers re-renders
        if (!window.pianoFunctions) {
            window.tp?.push(LogoutListener)
        }

        // giving Functions to global window
        // so it can be used by sourcepoint
        window.pianoFunctions = {
            pianoUserLogin,
            pianoUserRegister,
        }

        // checking if the current Cookies are used right
        if (window.S1_PIANO && window?.tp?.pianoId) {
            if (window.tp.pianoId.isUserValid()) {
                loadUserAPI((user, access) => {
                    saveUser({
                        email: user.email,
                        accessList: access?.access?.granted ? [ids.rid] : [],
                    })
                    if (!access?.access?.granted) {
                        /**
                         * if S1_PIANO says the user has access to PUR
                         * but the API says the user does not -> reload
                         * e.g. Subscription has been removed
                         */
                        location.reload()
                    }
                })
            } else {
                clearAllCookies()
                location.reload()
            }
        }
    }, [])

    return null
}

export default PianoSupport
